// extracted by mini-css-extract-plugin
module.exports = {"copyright":"CopyRight__copyright___2ocs-"};